const restaurant = {
  restaurant: "Restaurant",
  restaurants: "Restaurants",
  category: "Category",
  score: "Score",
  priceQuartile: "Price quartile",
  scoreLowestFirst: "Score (lowest first)",
  scoreHighestFirst: "Score (highest first)",
  priceLowestFirst: "Price (lowest first)",
  priceHighestFirst: "Price (highest first)",
  allPrices: "All prices",
  reserve: "Reserve",
  dining: "Dining",
};

export default restaurant;
